import { find } from 'lodash';
import usStateAbbreviation from 'common/constants/usStateAbbreviation';

export const getStateDisplayName = (stateAbbr) =>
  find(usStateAbbreviation, { abbreviation: stateAbbr })?.name || stateAbbr;

export const CURRENT_WINDOW_DAYS = parseInt(
  process.env.REACT_APP_SHIPMENT_CURRENT_WINDOW_DAYS || '7',
  10
);

export const SHIPPED_MAX_WINDOW_DAYS = parseInt(
  process.env.REACT_APP_SHIPPED_MAX_WINDOW_DAYS || '60',
  10
);

export const getCreatedAfterForCurrentWindow = () => {
  const date = new Date();
  date.setDate(date.getDate() - CURRENT_WINDOW_DAYS);
  return date.toISOString();
};

export const getTodayDateString = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const getCreatedAfterForShippedMaxWindow = () => {
  const date = new Date();
  date.setDate(date.getDate() - SHIPPED_MAX_WINDOW_DAYS);
  return date.toISOString();
};

export const getStartOfToday = () => {
  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  return date.toISOString();
};

export const getStartOfYesterday = () => {
  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  date.setDate(date.getDate() - 1);
  return date.toISOString();
};
